



























































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import { features, roles } from "@/config/roles";

import { getElegantDateString } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";
import { sortByDesc } from "@/utils/sort-helpers";

/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";


/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { Guid } from "@/domain/guid";

/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");


/**
 * Compositions page.
 */
@Component({
	components: {
		GroupCard
	}
})
export default class CompositionsPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	getElegantDateString = getElegantDateString;

	teamUrl = teamUrl;

	/// Props


	/// Attributes
	isLoading = false;
	compositionGroup: GetOneCompositionGroupResponse | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get isEditing() {
		return this.$route.fullPath.endsWith("edit");
	}

	get canManageCompositions() {
		return this.hasPermission(roles.MANAGE_COMPOSITIONS);
	}

	get canCopyAddonString() {
		return this.hasFeaturePermission(features.DISCORD);
	}

	get isThereAnyCharacter() {
		if (this.compositionGroup == null) {
			return false;
		}
		return this.compositionGroup.compositions.some(x => x.characters.length > 0);
	}

	/// Methods
	async fetchCurrentCompositionGroup() {
		await this.fetchCompositionGroup(this.$route.params.id);
	}

	async fetchCompositionGroup(id: Guid) {
		this.compositionGroup = await compositionsAPI.fetchCompositionGroup(id, true, true);
	}

	handleCopyAddonStringClick() {
		if (this.compositionGroup != null) {
			const addonString = this.compositionGroup.compositions.filter(x => x.characters.length > 0)
				.map((composition) => `${composition.name}@${composition.characters.sort(sortByDesc(x => x.role ?? "")).map(character => `${character.name}-${character.realm}|${character.role}`).join(";")}`).join("~");
			navigator.clipboard.writeText(addonString);
			this.$snackbar.openInfo(this.$t("snackbar.copied_to_clipboard"));
		}
	}

}
